/* eslint-disable import/no-anonymous-default-export */
// © Microsoft Corporation. All rights reserved.
import React from 'react';
import { Stack, Dropdown, IDropdownOption } from '@fluentui/react';
import { localSettingsContainer, micStackTokens, mainStackTokens, smallDropDownStyles } from './styles/LocalSettings.styles';
import { labelConstants, URLOptionsConstants } from '../core/constants';
import { DeviceType, IsHiddenMode } from '../Utils/Utils';
import { SetUserLocalSettingsProps, tryUpdateCandidateSetting} from '../core/sideEffects';

export interface IRemoteLocalSettingsProps {
    videoDeviceList: string[];
    audioDeviceList: string[];
    videoDevice: string;
    audioDevice: string;
    videoIndex: number;
    audioIndex: number;
    userId: string;
}

export class RemoteLocalSettingsProps implements IRemoteLocalSettingsProps {
    private _videoDevice: string;
    private _audioDevice: string;
    private _videoDeviceList: string[] = [];
    private _audioDeviceList: string[] = [];
    private _userId: string = '';
    private _videoIndex: number = -1;
    private _audioIndex: number = -1;

    constructor(
        public videoDevice: string,
        public audioDevice: string,
        public videoList: string[],
        public audioList: string[],
        public videoindex: number,
        public audioindex: number,
        public userid: string
    ) {
        this._videoDevice = videoDevice;
        this._audioDevice = audioDevice;
        this._videoDeviceList = videoList;
        this._audioDeviceList = audioList;
        this._videoIndex = videoindex;
        this._audioIndex = audioindex;
        this._userId = userid;
    }

    public get videoDeviceList(): string[] {
        return this._videoDeviceList;
    }
    public get audioDeviceList(): string[] {
        return this._audioDeviceList;
    }
    public set videoDeviceList(value: string[]) {
        this._videoDeviceList = value;
    }
    public set audioDeviceList(value: string[]) {
        this._audioDeviceList = value;
    }

    public get videoDeviceSelectedIndex(): string {
        return this._videoDevice;
    }
    public get audioDeviceSelectedIndex(): string {
        return this._audioDevice;
    }
    public set videoDeviceSelectedIndex(value: string) {
        this._videoDevice = value;
    }
    public set audioDeviceSelectedIndex(value: string) {
        this._audioDevice = value;
    }
    public get userId(): string {
        return this._userId;
    }
    public set userId(value: string) {
        this._userId = value;
    }

    public get videoIndex(): number {
        return this._videoIndex;
    }
    public set videoIndex(value: number) {
        this._videoIndex = value;
    }

    public get audioIndex(): number {
        return this._audioIndex;
    }
    public set audioIndex(value: number) {
        this._audioIndex = value;
    }
}

let selectedCameraId: string = '';
let selectedMicrophoneId: string = '';

const urlParams = new URLSearchParams(window.location.search.substring(1));
const threadId = urlParams.get(URLOptionsConstants.THREADID);

export default (propsOrig: IRemoteLocalSettingsProps): JSX.Element => {
    Object.freeze(propsOrig);
    const props = { ...propsOrig };
    const cameraByIndex = props.videoDeviceList[props.videoIndex];
    props.videoDevice = cameraByIndex;
    const defaultPlaceHolder = labelConstants.DefaultPlaceHolder;

    const getVideoDropDownList = (list: string[]): IDropdownOption[] => {
        if (list.length > 0) {
            if (!props.videoDevice && selectedCameraId === '') {
                selectedCameraId = list[0];
            }
            else {
                list.forEach((data) => {
                   
                    if (data === props.videoDevice )
                        selectedCameraId = data;
                });
            }
        }

        list = list.sort((a, b) =>
            a > b ? 1 : -1,
        );

        return list.map((item) => ({
            val: item,
            key: item,
            text: item
        }));
    };

    const getAudioDropDownList = (list: string[]): IDropdownOption[] => {
        if (list.length > 0) {
            if (!props.audioDevice && selectedMicrophoneId === '') {
                selectedMicrophoneId = list[0];
            }
            else {
                list.forEach((data) => {
                    if (data === props.audioDevice && selectedMicrophoneId === '') {
                        selectedMicrophoneId = data;
                    }
                });
            }
        }

        return list.map((item) => ({
            val: item,
            key: item,
            text: item
        }));
    };


    const toggleSettings = (propsOrig: IRemoteLocalSettingsProps) => {
       
        let input: HTMLElement = document.getElementById("toggleSettings" + propsOrig.userId) as HTMLElement;
        if (input != null) {
            input.click();
            var event = new Event('input', { bubbles: true });
            input.dispatchEvent(event);
        }
    };

    const setLoading = (value: boolean) => {

        if (value)
            document.body.style.cursor = 'wait';
        else
            document.body.style.cursor = 'default';

    };
    return (
        <Stack className={localSettingsContainer} tokens={mainStackTokens}>
            <Dropdown
                id={"drpVideo"}
                placeholder={defaultPlaceHolder}
                label={labelConstants.Camera}
                options={(props.videoDeviceList) ? getVideoDropDownList(props.videoDeviceList) : []}
                styles={smallDropDownStyles}
                disabled={props.videoDeviceList?.length === 0 || IsHiddenMode()}
                defaultSelectedKey={(selectedCameraId ? selectedCameraId : '')}
                onChange={(...args): void => {
                    const index = args[2] ?? 0;
                    if (args[1]) {
                        selectedCameraId = args[1]?.text.toString();
                        props.videoDevice = args[1]?.text.toString(); //props.videoDeviceList[index];
                    }
                    props.videoIndex = index;
                    tryUpdateCandidateSetting(DeviceType.Camera, props.videoDevice, index, props.userId, threadId);
                    setTimeout(function () {
                        setLoading(true);
                        toggleSettings(propsOrig);
                    }, 500);

                    setTimeout(function () {
                        setLoading(false);
                        toggleSettings(propsOrig);
                    }, 4000);
                        SetUserLocalSettingsProps(props);                   
                }}
            />
            <Stack tokens={micStackTokens}>
                <Dropdown
                    id={"drpAudio"}
                    placeholder={defaultPlaceHolder}
                    label={labelConstants.Microphone}
                    styles={smallDropDownStyles}
                    disabled={props.audioDeviceList?.length === 0 || IsHiddenMode()}
                    options={props.audioDeviceList ? getAudioDropDownList(props.audioDeviceList) : []}
                    defaultSelectedKey={(selectedMicrophoneId ? selectedMicrophoneId : '')}
                    onChange={(...args): void => {
                        const index = args[2] ?? 0;
                        if (args[1]) {
                            props.audioDevice = args[1]?.text.toString(); //props.videoDeviceList[index];
                            selectedMicrophoneId = args[1]?.text.toString();
                        }
                        props.audioIndex = index;
                        tryUpdateCandidateSetting(DeviceType.Microphone, props.audioDevice, index, props.userId, threadId);
                        SetUserLocalSettingsProps(props);
                    }}
                />
            </Stack>
        </Stack>
    );
};